import React, { PropsWithChildren } from 'react'
import { HelpCircle } from 'react-feather'

import { Button } from '@frame/ui-primitives/button'

import { DataAttribute } from '@frame/types'

type Props = PropsWithChildren<{
  onClick?: () => void
}>

export function InformationCard({ children, onClick }: Props) {
  return (
    <div
      data-cy={DataAttribute.INFORMATION_CARD}
      className="flex items-center justify-between rounded-md bg-moss-200 p-4"
    >
      <div className="flex flex-col gap-2">{children}</div>
      {onClick && (
        <div>
          <Button border={false} Icon={HelpCircle} onClick={onClick} />
        </div>
      )}
    </div>
  )
}
